import React from "react";

interface BlogHeaderProps {
  introTitleRef?: React.RefObject<HTMLParagraphElement>;
  introSubtitleRef?: React.RefObject<HTMLParagraphElement>;
}

export const BlogHeader: React.FC<BlogHeaderProps> = ({
  introTitleRef,
  introSubtitleRef,
}) => {
  return (
    <div className="mx-[16px] mt-[56px] flex flex-col items-center lg:mx-[75px] lg:mt-[57px]">
      <p
        ref={introTitleRef}
        className="align-middle font-inter text-[32px] font-semibold capitalize leading-[100%] text-[#131313] lg:font-dm-sans lg:text-[72px] lg:tracking-[-0.03em]"
      >
        Giv Blog
      </p>
      <p
        ref={introSubtitleRef}
        className="mt-[16px] text-center align-middle font-inter text-[14px] font-normal leading-[140%] tracking-[0em] text-[#5A5A59] lg:mt-[24px] lg:text-[18px] lg:text-[#131313]"
      >
        Immerse yourself in our journey, one blog post at a time.
      </p>
    </div>
  );
};
